import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { DOMAIN, USERS_API_URL } from '../../config';
import { readFromStorage } from '../webStorage';
import Cookies from 'js-cookie';

const axiosConfig: AxiosRequestConfig = {
    baseURL: `${USERS_API_URL}` || 'http://localhost:3000/',
     headers: {
    'ngrok-skip-browser-warning': 'true',
  },
};

const userAxios = axios.create(axiosConfig);

const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
	Cookies.remove('accessToken', {
		domain: DOMAIN,
		path: '/',
	});
	Cookies.remove('refreshToken', {
		domain: DOMAIN,
		path: '/',
	});
	Cookies.remove('roles', {
		domain: DOMAIN,
		path: '/',
	});
    window.location.reload();
    // (window as any).Intercom('shutdown');
};

// reqeust intercpetor
userAxios.interceptors.request.use((config) => {
    const token = readFromStorage('accessToken');
    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...config,
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
                'ngrok-skip-browser-warning': 'true',
            },
        };
    }
    return config;
});

// Add a response interceptor
userAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const refreshToken = Cookies.get('refreshToken');
                    const response = await userAxios.put('/hotel-world-dom/access-token', { refreshToken });
                    const accessToken = response.data.data.accessToken;
                    Cookies.set('accessToken', accessToken, { 
						domain: DOMAIN,
						path: '/',
						secure: true,
						sameSite: 'None',
					});
                    axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
                    return userAxios(originalRequest);
                } catch (e) {
                    console.error(e);
                    logout();
                }
            } else {
                // logout();
            }
        }
        return Promise.reject(err);
    },
);

export const userAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
    }> =>
        async ({ url, method, data }) => {
            const baseUrl = axiosConfig.baseURL;
            try {
                const result = await userAxios({ url: baseUrl + url, method, data });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            };
        };

export default userAxios;
